var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBluePlayButton(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6587 8.79936C14.6505 8.03188 14.6505 6.53442 13.6587 5.76694C10.6611 3.44754 7.31391 1.61939 3.74237 0.350909L3.08989 0.119174C1.84162 -0.324166 0.523109 0.520395 0.35412 1.80894C-0.11804 5.40915 -0.11804 9.15714 0.354119 12.7574C0.523108 14.0459 1.84162 14.8905 3.08989 14.4471L3.74237 14.2154C7.31391 12.9469 10.6611 11.1188 13.6587 8.79936Z",
    fill: "#102689"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluePlayButton);
export default __webpack_public_path__ + "static/media/bluePlayButton.4cec13a03254e9dc50e5fc3bf26ccecf.svg";
export { ForwardRef as ReactComponent };